import { createContext, useContext } from "react";
import { useHandleBrandAlerts } from "./utils/useHandleBrandAlerts";
import { BRAND_ALERT_INITIAL_CONTEXT } from "./utils/constants";

const BrandAlertContext = createContext(BRAND_ALERT_INITIAL_CONTEXT);

const BrandAlertProvider = ({ children }) => {
  const {
    cancelAlert,
    getCurrentBrandAlert,
    currentContent,
    isInitialLoading,
    resetAlert,
    saveBrandAlert,
    setCurrentContent,
    productSourceId,
    setProductSourceId
  } = useHandleBrandAlerts();

  return (
    <BrandAlertContext.Provider
      value={{
        isInitialLoading,
        saveBrandAlert,
        currentContent,
        setCurrentContent,
        cancelAlert,
        resetAlert,
        getCurrentBrandAlert,
        productSourceId,
        setProductSourceId
      }}
    >
      {children}
    </BrandAlertContext.Provider>
  );
};

const useBrandAlertContext = () => useContext(BrandAlertContext);

export { BrandAlertProvider, useBrandAlertContext };
